'use client';

import { Session } from 'next-auth';
import { SessionProvider } from 'next-auth/react';
import React from 'react';
import LoginCurtainWrapper from '@/components/organisms/login-curtain/login-curtain-wrapper';
import PageTemplateTracker from '@/components/utilities/page-template-tracker/page-template-tracker';
import { BookingFlowContextProvider } from '@/libraries/contexts/booking-flow-context/booking-flow-context';
import { PageDetailsProvider } from '@/libraries/contexts/page-details-context/page-details-context';
import { UserProfileContextProvider } from '@/libraries/contexts/user-profile-context/user-profile-context';

export interface TertiaryPageLayoutProps {
  $type?: string;
  bookingType?: Content.Components['BookingType'];
  brand: Content.Properties.Brand;
  children?: React.ReactNode;
  destinationId?: number;
  hotelDetails?: Content.PageType.HotelPage['hotelDetails'];
  offerDetails?: Content.PageType.HotelPage['offerDetails'];
  searchWidgetState?: Content.Components['SearchWidgetState'];
  session?: Session | null;
  trackingData: Content.Properties.TrackingData;
  userProfile?: Content.Components['GetUserProfileResponse'];
}

const TertiaryPageLayout = ({
  $type,
  bookingType,
  brand,
  children,
  destinationId,
  hotelDetails,
  offerDetails,
  searchWidgetState,
  session,
  trackingData,
  userProfile,
}: TertiaryPageLayoutProps) => {
  return (
    <SessionProvider basePath="/api/auth" session={session}>
      <PageDetailsProvider
        initialData={{
          bookingType,
          brand,
          destinationId,
          hasTransparentNavigation: false,
          hotelDetails,
          isInWebview: true,
          offerDetails,
          searchWidgetState,
          trackingData,
        }}
      >
        <BookingFlowContextProvider>
          <UserProfileContextProvider initialData={{ userProfile }}>
            <div data-brand={brand}>
              <PageTemplateTracker pageTemplate={$type} />

              {children}

              <LoginCurtainWrapper />
            </div>
          </UserProfileContextProvider>
        </BookingFlowContextProvider>
      </PageDetailsProvider>
    </SessionProvider>
  );
};

export default TertiaryPageLayout;
